import { STATUS_OPTIONS } from './statusOptions';

export function buildSqlFilters({
        selectedFilters = [],
        selectedUsers = [],
        referenceFilter = '',
        identifierFilter = '',
        contractFilter = '',
        dateRange = null,
        removeSimulation = true
    }) {

    const filters = [];

    if (selectedFilters.length > 0) {
        const statusQueries = selectedFilters.map(filter => {
            const option = STATUS_OPTIONS.find(opt => opt.value === filter);
            return option?.filterValue;
        }).filter(Boolean);

        if (statusQueries.length > 0) {
            filters.push(`(${statusQueries.join(' or ')})`);
        }
    }

    if (referenceFilter.trim()) {
        filters.push(`(t.reference:like:'%${referenceFilter.trim()}%')`);
    }

    if (identifierFilter.trim()) {
        filters.push(`(s.siret LIKE '${identifierFilter.trim()}%' OR s.siren LIKE '${identifierFilter.trim()}%')`);
    }

    if (contractFilter && contractFilter.length > 0) {
        const contractQueries = contractFilter.map(contract => `(t.fk_type_contrat:=:'${contract}')`);
        filters.push(`(${contractQueries.join(' or ')})`);
    }

    if (selectedUsers.length > 0) {
        const userQueries = selectedUsers.map(userId => `(t.fk_user_author:=:${userId})`);
        filters.push(`(${userQueries.join(' or ')})`);
    }

    if (dateRange && dateRange.length === 2) {
        const start = dateRange[0].toLocaleDateString('en-ZA');
        const end = dateRange[1].toLocaleDateString('en-ZA');
        filters.push(`(t.date_cre:>:'${start}') and (t.date_cre:<:'${end}')`);
    }

    if (removeSimulation) {
        filters.push(`(t.accord:!=:'OK_FIN')`);
    }

    return filters.join(' and ');
}